/** @format */

// src/components/PermissionSection2.jsx
import React from "react";
import { PiMedalLight } from "react-icons/pi";
import { FaWalking } from "react-icons/fa";
import { TbReceiptTax } from "react-icons/tb";

function RolePermissionTwo({ rolePermissionIds, onTogglePermission }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Leave Management */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          <PiMedalLight />
          <span>Leave Management</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="leaveManagementOverview"
              checked={rolePermissionIds.includes("4")}
              onChange={() => onTogglePermission("4")}
            />
            <span className="ml-2 text-gray-700">
              Leave Management Overview
            </span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="employeeLeaveManagement"
              checked={rolePermissionIds.includes("110")}
              onChange={() => onTogglePermission("110")}
            />
            <span className="ml-2 text-gray-700">
              Employee Leave Management
            </span>
          </label>

          <div className="ml-4">
            <label className="inline-flex items-inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="leaveHistory"
                checked={rolePermissionIds.includes("1003")}
                onChange={() => onTogglePermission("1003")}
              />
              <span className="ml-2 text-gray-700">Assign Leaves</span>
            </label>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="viewLeaveCounts"
                  checked={rolePermissionIds.includes("10003")}
                  onChange={() => onTogglePermission("10003")}
                />
                <span className="ml-2 text-gray-700">
                  View Short Leave Counts
                </span>
              </label>
            </div>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="leaveApprovalProcess"
              checked={rolePermissionIds.includes("120")}
              onChange={() => onTogglePermission("120")}
            />
            <span className="ml-2 text-gray-700">Leave Approval Process</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="calendar"
              checked={rolePermissionIds.includes("130")}
              onChange={() => onTogglePermission("130")}
            />
            <span className="ml-2 text-gray-700">Calendar</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="leaveRequest"
              checked={rolePermissionIds.includes("140")}
              onChange={() => onTogglePermission("140")}
            />
            <span className="ml-2 text-gray-700">Leave Request</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-checkbox h-5 w-5 text-gray-600"
                name="action"
                checked={rolePermissionIds.includes("10004")}
                onChange={() => onTogglePermission("10004")}
              />
              <span className="ml-2 text-gray-700">Action</span>
            </label>
          </div>
        </div>
      </div>

      {/* Payroll Management */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          <FaWalking />

          <span>Payroll Management</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="payrollManagementOverview"
              checked={rolePermissionIds.includes("5")}
              onChange={() => onTogglePermission("5")}
            />
            <span className="ml-2 text-gray-700">
              Payroll Management Overview
            </span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="payrollNavigation"
              checked={rolePermissionIds.includes("150")}
              onChange={() => onTogglePermission("150")}
            />
            <span className="ml-2 text-gray-700">Payroll Navigation</span>
          </label>

          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="monthEndPayroll"
                checked={rolePermissionIds.includes("1004")}
                onChange={() => onTogglePermission("1004")}
              />
              <span className="ml-2 text-gray-700">Month end Payroll</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="payrollAllowance"
                checked={rolePermissionIds.includes("1005")}
                onChange={() => onTogglePermission("1005")}
              />
              <span className="ml-2 text-gray-700">Payroll Allowance</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="payrollDeduction"
                checked={rolePermissionIds.includes("1006")}
                onChange={() => onTogglePermission("1006")}
              />
              <span className="ml-2 text-gray-700">Payroll Deduction</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="salaryBreakdown"
                checked={rolePermissionIds.includes("1007")}
                onChange={() => onTogglePermission("1007")}
              />
              <span className="ml-2 text-gray-700">Salary Breakdown</span>
            </label>
          </div>

          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="salaryAdvance"
                checked={rolePermissionIds.includes("1008")}
                onChange={() => onTogglePermission("1008")}
              />
              <span className="ml-2 text-gray-700">Salary Advance</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="colaAllowance"
                checked={rolePermissionIds.includes("1009")}
                onChange={() => onTogglePermission("1009")}
              />
              <span className="ml-2 text-gray-700">Cola Allowance</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="spectaclesAllowance"
                checked={rolePermissionIds.includes("1010")}
                onChange={() => onTogglePermission("1010")}
              />
              <span className="ml-2 text-gray-700">Spectacles Allowance</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="reimbursement"
                checked={rolePermissionIds.includes("1011")}
                onChange={() => onTogglePermission("1011")}
              />
              <span className="ml-2 text-gray-700">Reimbursement</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="medicalAllowance"
                checked={rolePermissionIds.includes("1012")}
                onChange={() => onTogglePermission("1012")}
              />
              <span className="ml-2 text-gray-700">Medical Allowance</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="billReimbursement"
                checked={rolePermissionIds.includes("1013")}
                onChange={() => onTogglePermission("1013")}
              />
              <span className="ml-2 text-gray-700">Bill Reimbursement</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="budgetaryAllowance"
                checked={rolePermissionIds.includes("1014")}
                onChange={() => onTogglePermission("1014")}
              />
              <span className="ml-2 text-gray-700">Budgetary Allowance</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="salaryArrears"
                checked={rolePermissionIds.includes("1015")}
                onChange={() => onTogglePermission("1015")}
              />
              <span className="ml-2 text-gray-700">Salary Arrears</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="loanManagement"
              checked={rolePermissionIds.includes("160")}
              onChange={() => onTogglePermission("160")}
            />
            <span className="ml-2 text-gray-700">Loan Management</span>
          </label>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          <TbReceiptTax />
          <span>Reports Section</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="reportsSectionOverview"
              checked={rolePermissionIds.includes("6")}
              onChange={() => onTogglePermission("6")}
            />
            <span className="ml-2 text-gray-700">Reports Section Overview</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="attendanceReport"
              checked={rolePermissionIds.includes("1016")}
              onChange={() => onTogglePermission("1016")}
            />
            <span className="ml-2 text-gray-700">Attendance Report</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="reportOfCheckInAndCheckOut"
                checked={rolePermissionIds.includes("10005")}
                onChange={() => onTogglePermission("10005")}
              />
              <span className="ml-2 text-gray-700">
                Report of Check In & Check Out
              </span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="reportOfAbsence"
                checked={rolePermissionIds.includes("10006")}
                onChange={() => onTogglePermission("10006")}
              />
              <span className="ml-2 text-gray-700">Report of Absence</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="employeeReport"
              checked={rolePermissionIds.includes("1017")}
              onChange={() => onTogglePermission("1017")}
            />
            <span className="ml-2 text-gray-700">Employee Report</span>
          </label>
          <div>
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-checkbox h-5 w-5 text-gray-600"
                name="payrollReport"
                checked={rolePermissionIds.includes("1018")}
                onChange={() => onTogglePermission("1018")}
              />
              <span className="ml-2 text-gray-700">Payroll Report</span>
            </label>

            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="generatedPayrollReport"
                  checked={rolePermissionIds.includes("10007")}
                  onChange={() => onTogglePermission("10007")}
                />
                <span className="ml-2 text-gray-700">
                  Generated Payroll Report
                </span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="epfReport"
                  checked={rolePermissionIds.includes("10008")}
                  onChange={() => onTogglePermission("10008")}
                />
                <span className="ml-2 text-gray-700">E.P.F Report</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="etfReport"
                  checked={rolePermissionIds.includes("10009")}
                  onChange={() => onTogglePermission("10009")}
                />
                <span className="ml-2 text-gray-700">E.T.F Report</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="bankslipReport"
                  checked={rolePermissionIds.includes("10010")}
                  onChange={() => onTogglePermission("10010")}
                />
                <span className="ml-2 text-gray-700">Bank Slip Report</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RolePermissionTwo;
